
import breakpointMixin from '~/mixins/breakpoints'
export default {
  mixins: [breakpointMixin],
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  computed: {
    containerStyles() {
      const padding = this.getBreakpointValue(this.blok.padding)
      const margin = this.getBreakpointValue(this.blok.margin)

      return `
        color: ${this.blok.textColorOverride};
        padding: ${padding};
        margin: ${margin};
        ${this.blok.styles}
      `
    },
  },
}
